module.exports = __webpack_public_path__ + "static/media/mysqllogo.4ccd3dff.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/mysqllogo.png
// module id = 831
// module chunks = 0